var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm._class},[_c('SelectBox',_vm._b({},'SelectBox',_vm.beforeSelectBoxProps,false,true)),_c('Action',_vm._b({},'Action',_vm.actionProps,false,true)),_c('SelectBox',_vm._b({},'SelectBox',_vm.afterSelectBoxProps,false,true))],1)}
var staticRenderFns = []

export { render, staticRenderFns }